import Vue from 'vue';

export default new Vue({
  data: {},
  methods: {
    /**
     * @description
     * Load list of clients
     *
     * @returns {Promise<clientListItem[]>}
     */
    async getClients(rawParams) {
      const params = {
        qLastName: rawParams.qLastName || undefined,
        qFirstName: rawParams.qFirstName || undefined,
        qPesel: rawParams.qPesel || undefined,
        qCity: rawParams.qCity || undefined,
        qStreet: rawParams.qStreet || undefined,
        qZgodaNpdo: rawParams.qZgodaNpdo || undefined,
        qZgodaNprd: rawParams.qZgodaNprd || undefined,
        qZgodaNoih: rawParams.qZgodaNoih || undefined,
        qZgodaEmail: rawParams.qZgodaEmail || undefined,
        qApplicableLoyaltyCard: rawParams.qApplicableLoyaltyCard || undefined,
        qLoyaltyCard: rawParams.qLoyaltyCard || undefined,
        sortOrder: rawParams.sortOrder || undefined,
        orderBy: rawParams.orderBy || undefined,
        qStatus: rawParams.qStatus || 'active',
        offset: rawParams.offset || 0,
        pageSize: rawParams.pageSize || 10,
      };
      return await this.$http.get('/api/clients', { params })
        .then(response => response);
    },
    /**
     * @description
     * Update client data
     * @param {clientDetailsItem} clientData
     * @returns {Promise<void>}
     */
    async updateClientData(clientData) {
      return await this.$http.put(`/api/clients/${clientData.clientId}`, { clientData });
    },

    async updateClientActiveStatus(clientData) {
      return await this.$http.post(`/api/clients/activation/${clientData.clientId}`, { isActive: !clientData.isActive });
    },

    async updateInvoiceLoyaltyStatus(invoice) {
      return await this.$http.post(`/api/clients/toggle-loyalty-invoice/${invoice.invoiceId}`, { loyaltyStatus: !invoice.loyaltyStatus });
    },

    async sendToPlaza(clientId, branchId) {
      return await this.$http.post('/api/clients/create-plaza', { clientId, branchId });
    },

    /**
     * @description
     * Merge clients into one client
     * @param {number} clientId
     * @param {object} clientData
     * @returns {Promise<void>}
     */
    async mergeClient(clientId, clientData) {
      return await this.$http.post(`/api/clients/merge/${clientId}`, clientData);
    },
    /**
     * @description
     * Connect client to another client as a subclient
     * @param {number} clientId
     * @param {number} parentClientId
     * @returns {Promise<void>}
     */
    async connectClient(clientId, parentClientId) {
      return await this.$http.post(`/api/clients/connect/${clientId}`, { parentClientId });
    },
    /**
     * @description
     * Disconnect client from his parent client
     * @param {number} clientId
     * @returns {Promise<void>}
     */
    async disconnectClient(clientId,) {
      return await this.$http.post(`/api/clients/disconnect/${clientId}`);
    },
    /**
     * @description
     * Update client's initial loyalty balance
     * @param {number} clientId
     * @param {number} balance
     * @returns {Promise<void>}
     */
    async updateInitialLoyaltyBalance(clientId, balance) {
      return await this.$http.post(`/api/clients/initial-loyalty-balance/${clientId}`, { balance });
    },
    /**
     * @description
     * Load given client details
     *
     * @param {number} clientId
     * @returns {Promise<*|HttpResponse>}
     */
    async getClientDetails(clientId) {
      if (!clientId) {
        return await false;
      }
      return await this.$http.get(`/api/clients/${clientId}`);
    },
    /**
     * @description
     * Get list of invoices for given client
     * @param {number} clientId
     * @returns {Promise<*|HttpResponse>}
     */
    async getClientInvoices(clientId) {
      if (!clientId) {
        return await false;
      }
      return await this.$http.get(`/api/clients/${clientId}/invoices`);
    },
    /**
     * @description
     * Get list of stays for given client
     * @param {number} clientId
     * @returns {Promise<*|HttpResponse>}
     */
    async getClientStays(clientId) {
      if (!clientId) {
        return await false;
      }
      return await this.$http.get(`/api/clients/${clientId}/stays`);
    },
    /**
     * @description
     * Get list of child clients for given client
     * @param {number} clientId
     * @returns {Promise<*|HttpResponse>}
     */
    async getChildClients(clientId) {
      if (!clientId) {
        return await false;
      }
      return await this.$http.get(`/api/clients/${clientId}/child-clients`);
    },
    /**
     * @description
     * Get given client's history
     * @param {number} clientId
     * @returns {Promise<*|HttpResponse>}
     */
    async getClientsHistory(clientId) {
      if (!clientId) {
        return await false;
      }
      return await this.$http.get(`/api/clients/${clientId}/history`);
    },
    /**
     * @description
     * Get list of loyalty cards for given client
     * @param {number} clientId
     * @returns {Promise<*|HttpResponse>}
     */
    async getClientCards(clientId) {
      if (!clientId) {
        return await false;
      }
      return await this.$http.get(`/api/clients/${clientId}/loyalty-cards`);
    },
  }
});